module.exports = __webpack_public_path__ + "assets/retina_LineAlongPointsDetailed.e8db5d15e9ec5c19cd0f2509d60b46c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_LineAlongPointsDetailed.png
// module id = 689
// module chunks = 0